import { memo } from 'react';

import { Col, Row } from 'antd';

function DetailsItem({ title, data, isDataHtml = true }) {
  return (
    <Row>
      <Col span={8} className="text-capitalize font-medium">
        {title}
      </Col>
      {isDataHtml && <Col span={16} className="text-capitalize" dangerouslySetInnerHTML={{ __html: data }}></Col>}
      {!isDataHtml && (
        <Col span={16} className="text-capitalize">
          {data}
        </Col>
      )}
    </Row>
  );
}

export default memo(DetailsItem);
